<!-- 文字跑马灯 -->
<template>
  <div class="wrap">
    <div ref="box" class="box">
      {{ content }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      default: '',
    },
    intervalTime: {
      type: Number,
      default: 50,
    },
    intervalPx: {
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      timer: null,
    }
  },
  methods: {
    startText() {
      if (this.timer != null) return
      // 获取宽度这里优化了一下, 直接从dom获取
      const width = Math.floor(this.$refs.box.getBoundingClientRect().width)
      let distance = 0 // 设为0从左侧开始播放

      this.timer = setInterval(() => {
        distance = distance - Number(this.intervalPx)
        // 如果位移超过文字宽度，则回到起点
        if (-distance >= width) {
          distance = 0
        }
        this.$refs.box.style.transform = 'translateX(' + distance + 'px)'
      }, this.intervalTime)
    },
    stopText() {
      // 清除定时器
      clearInterval(this.timer)
      // 清除定时器之后，需要重新将定时器置为null
      this.timer = null
    },
  },
  mounted() {
    this.startText()
  },
  destroyed() {
    this.stopText()
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  overflow: hidden;
}

.box {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}
</style>
